// Create CompanyContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const CompanyContext = createContext();

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within CompanyProvider');
  }
  return context;
};

export const CompanyProvider = ({ children }) => {
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companies, setCompanies] = useState([]);

  const selectCompany = (company) => {
    setSelectedCompany(company);
    // Save to localStorage
    try {
      localStorage.setItem('selectedCompany', JSON.stringify(company));
    } catch (error) {
      console.error('Failed to save company:', error);
    }
  };

  // Load from localStorage on mount
  useEffect(() => {
    const saved = localStorage.getItem('selectedCompany');
    if (saved) {
      try {
        setSelectedCompany(JSON.parse(saved));
      } catch (error) {
        localStorage.removeItem('selectedCompany');
      }
    }
  }, []);

  return (
    <CompanyContext.Provider value={{
      selectedCompany,
      companies,
      setCompanies,
      selectCompany
    }}>
      {children}
    </CompanyContext.Provider>
  );
};